export const getFileExtension = (file: File): string | undefined => {
  const regex = /(?:\.([^.]+))?$/;
  return regex.exec(file.name)?.[1] || file.name.split('.')?.pop();
};
